import { useState } from "react";

import BrandManager from "utils/BrandManager/brandManager";

export function useBrand() {
    // use lazy initial: https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
    const [BrandManagerRef] = useState<ReturnType<typeof BrandManager>>(BrandManager());
    return BrandManagerRef;
}
